import { useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Universities from './components/Universities';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <Process />
      <Universities />
      <Testimonials />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
